(ns manage.poi.selectors.view
  (:require ["@mui/material/Autocomplete$default" :as Autocomplete]
            ["@mui/material/Button$default" :as Button]
            ["@mui/material/Stack$default" :as Stack]
            ["@mui/material/TextField$default" :as TextField]
            ["@mui/x-data-grid-premium" :refer [DataGridPremium useGridApiRef]]
            ["src/svg/shapes/rectangle/rectangle-split-3x1.svg$default" :as ColumnsIcon]
            [cljs-bean.core :refer [->clj]]
            [common.modal.dialog :refer [deletion-confirmation]]
            [common.modal.view :refer [defmodal]]
            [common.queries :refer [use-mutation use-query]]
            [common.resource.query.poi :as poi.q]
            [manage.poi.selectors.columns :refer [get-selector-id selector-columns]]
            [manage.poi.shared :refer [cursor-pagination use-cursor-pagination]]
            [re-frame.core :as rf]
            [reitit.frontend.easy :as r.easy]
            [uix.core :refer [$ defui] :as uix]
            [uix.re-frame :refer [use-subscribe]])
  (:require-macros [common.modal.view]))

(defmodal confirm-delete-selector :poi/confirm-delete-selector
  [{:keys [selector-id selector-name]}]
  (let [{:keys [advertiser-id]} (use-subscribe [:url-context])
        {delete-selector :mutate} (use-mutation (poi.q/delete-selector-mutation {:advertiser-id advertiser-id}))]
    (deletion-confirmation
     {:entity-name "Selector"
      :item-label selector-name
      :on-submit #(delete-selector selector-id
                                   #js {:onSuccess (fn [_] (rf/dispatch [:ocp/close]))})})))

(defui selectors []
  (let [api-ref (useGridApiRef)
        {:keys [advertiser-id] :as url-context} (use-subscribe [:url-context])
        {dataset-ready :isSuccess} (use-query (poi.q/ensure-dataset {:advertiser-id advertiser-id}))

        [selected-label set-selected-label] (uix/use-state nil)
        {:keys [cursor reset page-props]} (use-cursor-pagination)

        {available-labels :data} (use-query (poi.q/label-options-query {:advertiser-id advertiser-id
                                                                        :enabled? dataset-ready}))

        {page-data :data isPending :isPending}
        (use-query (poi.q/selectors-query {:advertiser-id advertiser-id
                                           :page-after (:page-after cursor)
                                           :page-before (:page-before cursor)
                                           :label selected-label
                                           :enabled? dataset-ready}))

        {:keys [items pagination-props]} (page-props page-data)]
    ($ :<>
       ($ Stack {:direction "row" :alignItems "center" :p 1 :spacing 1}
          ($ Autocomplete
             {:size "small"
              :options (to-array (or available-labels []))
              :value selected-label
              :onChange (fn [_ value]
                          (set-selected-label value)
                          (reset))
              :renderInput (fn [^js props]
                             ($ TextField (js/Object.assign props
                                                            #js {:placeholder (when (nil? selected-label)
                                                                                "Filter by label...")})))
              :sx #js {:minWidth "300px"}})
          ($ :div {:style {:flex 1}})
          ($ Button {:endIcon ($ ColumnsIcon)
                     :onClick #(.. api-ref -current (showPreferences "columns"))}
             "Columns")
          ($ Button {:variant "contained"
                     :onClick #(r.easy/push-state :advertiser/poi-selector
                                                  url-context
                                                  {:selector-id "new"})}
             "+ New Selector"))
       ($ DataGridPremium
          {:apiRef api-ref
           :columns (selector-columns (fn [{:keys [selector-id selector-name]}]
                                        (rf/dispatch [:modal/open {:id :poi/confirm-delete-selector
                                                                   :props {:selector-id selector-id
                                                                           :selector-name selector-name}}])))
           :loading isPending
           :rows (to-array (or items []))
           :getRowId get-selector-id
           :onRowClick (fn [^js params]
                         (let [row (->clj (.-row params))]
                           (r.easy/push-state :advertiser/poi-selector
                                              url-context
                                              {:selector-id (:id row)})))
           :disableRowSelectionOnClick true
           :disableColumnSorting true
           :disableColumnFilter true
           :hideFooter true
           :localeText #js {:noRowsLabel "No selectors found"}
           :initialState #js {:columns #js {:columnVisibilityModel #js {:archived false :notAllLabels false}}}
           :sx #js {:maxHeight "70rem"}})
       ($ cursor-pagination pagination-props))))
